// Warms the code-split chunk for a route so hover -> click feels instant.
// Loaders use the same module specifiers as App.js (webpack shares one chunk per module).

const P = {
  About: () => import('../pages/About'),
  Publications: () => import('../pages/Publications'),
  InTheNews: () => import('../pages/InTheNews'),
  Conferences: () => import('../pages/Conferences'),
  MediaKit: () => import('../pages/MediaKit'),
  AwardsMemberships: () => import('../pages/AwardsMemberships'),
  Contact: () => import('../pages/Contact'),
  Blog: () => import('../pages/Blog'),
  Resources: () => import('../pages/Resources'),
  Testimonials: () => import('../pages/TestimonialsPage'),
  Team: () => import('../pages/Team'),
  FAQ: () => import('../pages/FAQPage'),
  International: () => import('../pages/InternationalPatientsPage'),
  Fellowships: () => import('../pages/InternationalFellowshipsPage'),
  ACL: () => import('../pages/seo/ACLReconstruction'),
  KneeReplacement: () => import('../pages/seo/KneeReplacement'),
  HipReplacement: () => import('../pages/seo/HipReplacement'),
  KneeArthroscopy: () => import('../pages/seo/KneeArthroscopy'),
  SportsInjuries: () => import('../pages/seo/SportsInjuries'),
  MeniscalTears: () => import('../pages/seo/MeniscalTears'),
  RoboticSurgery: () => import('../pages/seo/RoboticSurgery'),
  Trauma: () => import('../pages/seo/Trauma'),
  TennisElbow: () => import('../pages/seo/TennisElbow'),
  GolfersElbow: () => import('../pages/seo/GolfersElbow'),
  ElbowPain: () => import('../pages/seo/ElbowPainTreatment'),
  FrozenShoulder: () => import('../pages/seo/FrozenShoulder'),
  RotatorCuffTear: () => import('../pages/seo/RotatorCuffTear'),
  ShoulderDislocation: () => import('../pages/seo/ShoulderDislocation'),
  CarpalTunnel: () => import('../pages/seo/CarpalTunnel'),
  TriggerFinger: () => import('../pages/seo/TriggerFinger'),
  ShoulderArthroscopy: () => import('../pages/seo/ShoulderArthroscopy'),
  ShoulderReplacement: () => import('../pages/seo/ShoulderReplacement'),
  ShoulderArthritis: () => import('../pages/seo/ShoulderArthritis'),
  KneeArthritis: () => import('../pages/seo/KneeArthritis'),
  HipArthritis: () => import('../pages/seo/HipArthritis'),
  CartilageRepair: () => import('../pages/seo/CartilageRepair'),
  AvascularNecrosis: () => import('../pages/seo/AvascularNecrosis'),
  AnkleInjuries: () => import('../pages/seo/AnkleInjuries'),
  JointReplacement: () => import('../pages/seo/JointReplacement'),
  DAAHip: () => import('../pages/seo/DAAHipReplacement'),
  OrthoSurgeon: () => import('../pages/seo/OrthoSurgeonHyderabad'),
  JointCost: () => import('../pages/seo/JointReplacementCost'),
  KneeRecovery: () => import('../pages/seo/KneeReplacementRecovery'),
  FrozenExercises: () => import('../pages/seo/FrozenShoulderExercises'),
  ShoulderPainNight: () => import('../pages/seo/ShoulderPainAtNight'),
  MedicalTourism: () => import('../pages/seo/MedicalTourismJointSurgery'),
  PhysioKnee: () => import('../pages/seo/PhysiotherapyAfterKneeSurgery'),
  HipRecovery: () => import('../pages/seo/HipReplacementRecovery'),
  RotatorCuffCost: () => import('../pages/seo/RotatorCuffSurgeryCost'),
};

const ROUTES = {
  '/about': P.About,
  '/publications': P.Publications, '/research': P.Publications,
  '/in-the-news': P.InTheNews, '/media': P.InTheNews,
  '/conferences': P.Conferences, '/talks': P.Conferences,
  '/media-kit': P.MediaKit,
  '/awards': P.AwardsMemberships, '/awards-memberships': P.AwardsMemberships,
  '/contact': P.Contact, '/contact-us': P.Contact,
  '/blog': P.Blog,
  '/resources': P.Resources,
  '/testimonials': P.Testimonials, '/reviews': P.Testimonials, '/patient-reviews': P.Testimonials,
  '/team': P.Team,
  '/faq': P.FAQ, '/faqs': P.FAQ,
  '/international-patients': P.International, '/medical-tourism': P.International,
  '/fellowships': P.Fellowships, '/international-training': P.Fellowships, '/credentials': P.Fellowships,
  '/precision-surgery': P.RoboticSurgery, '/computer-navigation': P.RoboticSurgery,
  '/acl-reconstruction': P.ACL, '/acl-surgery-anterior-cruciate-ligament': P.ACL, '/knee-ligament-injuries': P.ACL,
  '/knee-replacement': P.KneeReplacement, '/total-knee-replacement': P.KneeReplacement,
  '/total-knee-replacement-hyderabad': P.KneeReplacement, '/knee-joint-replacement-surgery-in-hyderabad': P.KneeReplacement,
  '/hip-replacement': P.HipReplacement, '/total-hip-replacement-hyderabad': P.HipReplacement,
  '/hip-joint-replacement-surgery-in-hyderabad': P.HipReplacement,
  '/knee-arthroscopy': P.KneeArthroscopy,
  '/sports-injuries': P.SportsInjuries,
  '/meniscal-tears': P.MeniscalTears,
  '/robotic-surgery': P.RoboticSurgery, '/robotic-knee-replacement-surgery-in-hyderabad': P.RoboticSurgery,
  '/trauma': P.Trauma, '/fractures-treatment-in-hyderabad': P.Trauma,
  '/tennis-elbow': P.TennisElbow, '/elbow-replacement-hyderabad': P.TennisElbow,
  '/golfers-elbow': P.GolfersElbow, '/elbow-surgery': P.GolfersElbow, '/elbow-arthroscopy': P.GolfersElbow,
  '/elbow-fracture-surgery-in-hyderabad': P.GolfersElbow, '/elbow-replacement-surgery-in-hyderabad': P.GolfersElbow,
  '/elbow-pain-treatment-hyderabad': P.ElbowPain, '/elbow-pain-hyderabad': P.ElbowPain, '/elbow-pain-treatment': P.ElbowPain,
  '/frozen-shoulder': P.FrozenShoulder, '/non-surgical-shoulder-treatment-in-hyderabad': P.FrozenShoulder,
  '/rotator-cuff-tear': P.RotatorCuffTear, '/rotator-cuff-repair': P.RotatorCuffTear,
  '/rotator-cuff-repair-surgery-in-hyderabad': P.RotatorCuffTear,
  '/shoulder-dislocation': P.ShoulderDislocation,
  '/carpal-tunnel': P.CarpalTunnel, '/hand-fractures-treatment-in-hyderabad': P.CarpalTunnel,
  '/trigger-finger': P.TriggerFinger,
  '/shoulder-arthroscopy': P.ShoulderArthroscopy, '/shoulder-surgery': P.ShoulderArthroscopy,
  '/shoulder-reconstruction-hyderabad': P.ShoulderArthroscopy, '/shoulder-reconstruction-surgeon-in-hyderabad': P.ShoulderArthroscopy,
  '/shoulder-replacement': P.ShoulderReplacement, '/shoulder-hemiarthroplasty': P.ShoulderReplacement,
  '/anatomic-total-shoulder-arthroplasty': P.ShoulderReplacement, '/reverse-shoulder-arthroplasty': P.ShoulderReplacement,
  '/shoulder-replacement-surgery-in-hyderabad': P.ShoulderReplacement,
  '/shoulder-arthritis': P.ShoulderArthritis,
  '/knee-arthritis': P.KneeArthritis,
  '/hip-arthritis': P.HipArthritis,
  '/cartilage-repair': P.CartilageRepair,
  '/avascular-necrosis': P.AvascularNecrosis,
  '/ankle-injuries': P.AnkleInjuries,
  '/joint-replacement': P.JointReplacement, '/lower-limb-orthopedic-specialist-hyderabad': P.JointReplacement,
  '/daa-hip-replacement': P.DAAHip, '/daa-minimally-invasive-anterior-approach-hip-replacement': P.DAAHip,
  '/orthopedic-surgeon-hyderabad': P.OrthoSurgeon, '/best-ortho-doctor-hyderabad': P.OrthoSurgeon,
  '/ortho-specialist-hyderabad': P.OrthoSurgeon, '/best-orthopedic-surgeon-in-hyderabad': P.OrthoSurgeon,
  '/joint-replacement-cost-hyderabad': P.JointCost, '/knee-replacement-cost-hyderabad': P.JointCost,
  '/hip-replacement-cost-hyderabad': P.JointCost, '/surgery-cost-india': P.JointCost,
  '/knee-replacement-recovery-timeline': P.KneeRecovery, '/knee-replacement-recovery': P.KneeRecovery,
  '/recovery-after-knee-replacement': P.KneeRecovery,
  '/exercises-for-frozen-shoulder': P.FrozenExercises, '/frozen-shoulder-exercises': P.FrozenExercises,
  '/shoulder-pain-at-night': P.ShoulderPainNight, '/night-shoulder-pain': P.ShoulderPainNight,
  '/medical-tourism-joint-surgery-india': P.MedicalTourism, '/joint-surgery-india-medical-tourism': P.MedicalTourism,
  '/physiotherapy-after-knee-surgery': P.PhysioKnee, '/knee-replacement-physiotherapy': P.PhysioKnee,
  '/hip-replacement-recovery': P.HipRecovery, '/hip-replacement-recovery-timeline': P.HipRecovery,
  '/recovery-after-hip-replacement': P.HipRecovery,
  '/rotator-cuff-surgery-cost-india': P.RotatorCuffCost, '/rotator-cuff-repair-cost': P.RotatorCuffCost,
};

const done = new Set();

export function prefetchPath(pathname) {
  if (!pathname) return;
  const clean = pathname.replace(/\/+$/, '') || '/';
  if (done.has(clean)) return;
  const loader = ROUTES[clean];
  if (loader) {
    done.add(clean);
    loader().catch(() => done.delete(clean));
  }
}
